
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

@Component({
  name: 'ConfirmationDialog',
})
export default class ConfirmationDialog extends Vue {
  @Prop({ default: false, required: false, type: Boolean }) state!: boolean;
  @Prop({ default: null, type: Number }) slug!: string;

  @Emit('actions')
  close() {
    return {
      state: false,
      idx: 'confirm',
    };
  }
}
